export default function MentionsLegales() {
  return (
    <div className="bg-[#FDFBF7] min-h-screen pt-16" data-testid="mentions-page">
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-20">
        <span className="font-script text-2xl text-[#A61C24]">Informations légales</span>
        <h1 className="font-serif text-4xl md:text-5xl text-[#1A1A1A] mt-2 mb-10">Mentions légales</h1>

        <div className="space-y-8 text-[#1A1A1A]/85 leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl mb-3">Éditeur du site</h2>
            <p>Le Bistrot de la Neuve<br />
              Zone d'Activités de La Neuve<br />
              44 Rue du Plateau, 01440 Viriat, France<br />
              Téléphone : 04 74 45 35 10<br />
              Email : bdelaneuve@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Directeur de la publication</h2>
            <p>Le gérant du restaurant Le Bistrot de la Neuve.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Conception &amp; réalisation</h2>
            <p>
              Site conçu et développé par{" "}
              <a href="https://axeris-labs.fr" target="_blank" rel="noreferrer" className="text-[#A61C24] underline underline-offset-2">
                Axeris Labs
              </a>.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Hébergement</h2>
            <p>Le présent site est hébergé par son prestataire technique. Les coordonnées complètes de l'hébergeur sont communiquées sur simple demande par email.</p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus présents sur ce site (textes, images, logo, illustrations, photographies, mise en page) est la propriété exclusive de Le Bistrot de la Neuve, sauf mention contraire. Toute reproduction, représentation ou diffusion, totale ou partielle, est interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Responsabilité</h2>
            <p>
              Les informations diffusées sur ce site sont fournies à titre indicatif. Le Bistrot de la Neuve s'efforce d'en assurer l'exactitude et la mise à jour, sans pouvoir garantir l'absence totale d'erreurs. Les horaires et les cartes peuvent évoluer sans préavis.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Droit applicable</h2>
            <p>Le présent site est soumis au droit français. Tout litige relatif à son utilisation relève des tribunaux compétents.</p>
          </section>
        </div>
      </section>
    </div>
  );
}
